import "$styles/index.scss"

const GATE_KEY = "house-altera-after-dark"
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

function pathOnly(value) {
  return String(value || "").split(/[?#]/)[0].replace(/\/+$/, "") || "/"
}

function destFromNext() {
  const next = new URLSearchParams(window.location.search).get("next")
  if (next && next.startsWith("/") && !next.startsWith("//")) {
    const path = pathOnly(next)
    if (path !== "/" && path !== "/terms") return next
  }
  return "/home/"
}

function termsDialog() {
  const dialog = document.getElementById("terms-dialog")
  const open = document.getElementById("enter-terms")
  if (!dialog || !open) return

  const close = () => dialog.close()

  open.addEventListener("click", (event) => {
    event.preventDefault()
    dialog.showModal()
  })

  dialog.querySelectorAll("[data-close-terms]").forEach((button) => {
    button.addEventListener("click", close)
  })

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) close()
  })
}

function gate() {
  const isEnter = document.body.classList.contains("enter")
  const admitted = window.localStorage.getItem(GATE_KEY) === "1"

  if (!isEnter && !admitted) {
    const path = pathOnly(window.location.pathname)
    if (path === "/terms") {
      window.location.replace("/")
      return
    }
    const next = encodeURIComponent(window.location.pathname + window.location.search)
    window.location.replace(`/?next=${next}`)
    return
  }

  if (isEnter && admitted && !new URLSearchParams(window.location.search).has("next")) {
    window.location.replace("/home/")
    return
  }

  termsDialog()

  document.getElementById("enter-after-dark")?.addEventListener("click", (event) => {
    event.preventDefault()
    window.localStorage.setItem(GATE_KEY, "1")
    window.location.href = destFromNext()
  })
}

function nav() {
  const navEl = document.getElementById("site-nav")
  if (!navEl) return

  const toggle = navEl.querySelector(".nav-toggle")
  const setOpen = (open) => {
    navEl.classList.toggle("is-open", open)
    toggle?.setAttribute("aria-expanded", open ? "true" : "false")
    document.body.classList.toggle("nav-open", open)
  }

  window.addEventListener("scroll", () => {
    navEl.classList.toggle("scrolled", window.scrollY > 16)
  }, { passive: true })

  toggle?.addEventListener("click", () => {
    setOpen(!navEl.classList.contains("is-open"))
  })

  navEl.querySelectorAll(".nav-links a").forEach((link) => {
    link.addEventListener("click", () => setOpen(false))
  })
}

function rotateHeadlines() {
  const root = document.getElementById("hero-headline")
  if (!root || reduceMotion) return

  const slides = [...root.querySelectorAll(".hero-headline-slide")]
  if (slides.length < 2) return

  let index = 0
  const swap = () => {
    const current = slides[index]
    const nextIndex = (index + 1) % slides.length
    current.classList.remove("active")
    current.setAttribute("aria-hidden", "true")
    window.setTimeout(() => {
      slides[nextIndex].classList.add("active")
      slides[nextIndex].setAttribute("aria-hidden", "false")
      index = nextIndex
    }, 1400)
  }

  window.setInterval(swap, 8000)
}

function rotateTestimonials() {
  const root = document.getElementById("testimonial-rotator")
  if (!root) return

  const slides = [...root.querySelectorAll(".testimonial-slide")]
  if (slides.length < 2 || reduceMotion) return

  let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")))
  let timer

  const show = (next) => {
    slides[index].classList.remove("is-active")
    slides[index].setAttribute("aria-hidden", "true")
    index = (next + slides.length) % slides.length
    slides[index].classList.add("is-active")
    slides[index].setAttribute("aria-hidden", "false")
  }

  const start = () => {
    window.clearInterval(timer)
    timer = window.setInterval(() => show(index + 1), 6800)
  }

  root.addEventListener("mouseenter", () => window.clearInterval(timer))
  root.addEventListener("mouseleave", start)
  root.addEventListener("focusin", () => window.clearInterval(timer))
  root.addEventListener("focusout", (event) => {
    if (!root.contains(event.relatedTarget)) start()
  })
  start()
}

function fadeIns() {
  const nodes = document.querySelectorAll(
    ".hero-text, .recognition-statement, .about-band, .work-intro, .work-card, .explore-preview, .page-hero, .page-intro, .sig-card, .family-card, .legal-block, .tour-dates"
  )
  nodes.forEach((el) => el.classList.add("fade-in"))

  if (reduceMotion) {
    nodes.forEach((el) => el.classList.add("visible"))
    return
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible")
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.12 })

  nodes.forEach((el) => observer.observe(el))
}

function splitChars(el) {
  const text = el.textContent.trim()
  el.setAttribute("aria-label", text)
  el.textContent = ""
  ;[...text].forEach((ch, i) => {
    const span = document.createElement("span")
    span.className = "proof-char"
    span.setAttribute("aria-hidden", "true")
    span.textContent = ch
    span.style.setProperty("--i", String(i))
    el.appendChild(span)
  })
  el.style.setProperty("--n", String(text.length))
  el.style.setProperty("--mid", String((text.length - 1) / 2))
}

function proofWords() {
  const root = document.querySelector(".proof")
  const items = [...document.querySelectorAll(".proof-item")]
  if (!root || !items.length) return

  const needsChars = new Set(["letter-fade", "gather"])

  items.forEach((item) => {
    const number = item.querySelector(".proof-number")
    const label = item.querySelector(".proof-label")
    if (number && needsChars.has(item.dataset.wordAnim)) splitChars(number)
    if (label && item.dataset.labelAnim === "letters") splitChars(label)
    item.classList.add("is-armed")
    item.setAttribute("aria-hidden", "true")
  })

  let index = 0
  let timer = 0

  const activate = (i) => {
    items.forEach((item, n) => {
      item.classList.remove("is-on")
      item.classList.toggle("is-active", n === i)
      item.setAttribute("aria-hidden", n === i ? "false" : "true")
    })
    const current = items[i]
    void current.offsetWidth
    current.classList.add("is-on")
  }

  const start = () => {
    activate(0)
    if (items.length < 2) return
    timer = window.setInterval(() => {
      index = (index + 1) % items.length
      activate(index)
    }, reduceMotion ? 5000 : 4800)
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        start()
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.35 })

  observer.observe(root)
}

function gallery() {
  const root = document.querySelector("[data-gallery]")
  const dialog = document.getElementById("lightbox")
  const img = dialog?.querySelector("img")
  if (!root || !dialog || !img) return

  const items = [...root.querySelectorAll("[data-gallery-item]")]
  let index = 0

  const show = (i) => {
    index = (i + items.length) % items.length
    const link = items[index]
    const thumb = link.querySelector("img")
    img.src = link.getAttribute("href")
    img.alt = thumb?.alt || ""
    if (!dialog.open) dialog.showModal()
  }

  items.forEach((link, i) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()
      show(i)
    })
  })

  dialog.querySelector(".lightbox-close")?.addEventListener("click", () => dialog.close())
  dialog.querySelector(".lightbox-nav--prev")?.addEventListener("click", () => show(index - 1))
  dialog.querySelector(".lightbox-nav--next")?.addEventListener("click", () => show(index + 1))

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog || event.target === dialog.querySelector(".lightbox-figure")) {
      dialog.close()
    }
  })

  dialog.addEventListener("close", () => {
    img.src = ""
  })

  document.addEventListener("keydown", (event) => {
    if (!dialog.open) return
    if (event.key === "ArrowRight") show(index + 1)
    if (event.key === "ArrowLeft") show(index - 1)
  })
}

gate()
nav()
rotateHeadlines()
rotateTestimonials()
fadeIns()
proofWords()
gallery()
